import { useState } from "react";
import { Card } from "./ui/card";
import { Badge } from "./ui/badge";
import { Button } from "./ui/button";
import { MapPin, Play, ShoppingCart } from "lucide-react";

const YouTube = ({ id, title }) => {
  const [play, setPlay] = useState(false);
  if (!id) return null;
  return (
    <div className="relative aspect-video rounded-lg overflow-hidden bg-black mt-3" data-testid="partner-video">
      {play ? (
        <iframe className="absolute inset-0 h-full w-full" src={`https://www.youtube-nocookie.com/embed/${id}?autoplay=1`}
                title={title} allow="autoplay; encrypted-media; picture-in-picture" allowFullScreen />
      ) : (
        <button type="button" onClick={() => setPlay(true)} className="group absolute inset-0" aria-label="Assistir vídeo" data-testid="partner-video-play">
          <img src={`https://i.ytimg.com/vi/${id}/hqdefault.jpg`} alt="" className="h-full w-full object-cover opacity-80 group-hover:opacity-100 transition-opacity" />
          <span className="absolute inset-0 flex items-center justify-center">
            <span className="h-12 w-12 rounded-full bg-red-600 flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform"><Play className="h-5 w-5 text-white fill-white" /></span>
          </span>
        </button>
      )}
    </div>
  );
};

export const PartnerCompanyCard = ({ c, onBuy, canBuy }) => (
  <Card className="p-5 flex flex-col card-hover" data-testid={`partner-company-${c.id}`}>
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0">
        <div className="font-display text-lg font-bold leading-tight">{c.name}</div>
        <div className="flex flex-wrap items-center gap-2 mt-2">
          <Badge variant="outline">{c.service_type}</Badge>
          <span className="flex items-center gap-1 text-xs text-muted-foreground"><MapPin className="h-3 w-3" /> {c.state}</span>
        </div>
      </div>
      <div className="text-right shrink-0" data-testid={`partner-company-discount-${c.id}`}>
        <div className="font-mono text-3xl font-bold gold-text leading-none">{c.buyer_percent.toLocaleString("pt-BR")}%</div>
        <div className="text-[10px] uppercase tracking-[0.2em] text-emerald-500 mt-1">para você</div>
      </div>
    </div>
    <p className="mt-3 text-sm text-muted-foreground flex-1">{c.description}</p>
    <YouTube id={c.youtube_id} title={c.name} />
    <div className="mt-3 text-[11px] text-muted-foreground">Desconto total da empresa: {c.discount_percent.toLocaleString("pt-BR")}%</div>
    <Button size="sm" className="gold-btn mt-4" onClick={() => onBuy(c)} data-testid={`partner-company-buy-${c.id}`}>
      <ShoppingCart className="h-3 w-3 mr-2" /> {canBuy ? "Comprar com esta empresa" : "Entre para comprar"}
    </Button>
  </Card>
);
